import React from "react";
import PropTypes from "prop-types";

// core components
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import HeaderBanner from "../../components/banner/banner";
import TreePdfViewer from "../../components/Act/treePdfViewer";

const ActPage = () => {
    return (
        <div id="main-wrapper">
            <Header />
            <div className="page-wrapper">
                <div className="container-fluid">
                    <HeaderBanner heading="Act" />

                    <TreePdfViewer />


                </div>
            </div>
            <Footer />
        </div>
    );
}

ActPage.propTypes = {
    classes: PropTypes.object
};

export default ActPage;
